import type { Observable } from 'rxjs';
import type { FlexMonitorStatusResponse } from 'app/shared/models/flex-monitor-status';
import type { LocationDetails } from 'app/shared/models/location-details';
import type { OptimizedViewData } from 'app/shared/models/view-data';
import type { ApiUnitsRow } from 'app/shared/models/units';
import type { SignalRMessage } from 'app/shared/models/signalr-message';
import type {
    FlexDiagnosticCommandResponse,
    MonitorDiagnosticLog,
    MonitorDiagnosticLogsRequest,
} from 'app/shared/services/monitor-diagnostics.service';
import type { FlexMonitorConfiguration } from 'app/shared/components/location-card/store/configs/flex/models';
import type { SensorConfigurationCollection } from 'app/shared/components/location-card/store/models/dynamic-section-models';
import type { FlexDateContext, FlexInstallationDrawingData } from './flex-monitor-status.models';

export abstract class FlexMonitorStatusDataSource {
    public abstract getStatus(customerId: number, locationId: number): Observable<FlexMonitorStatusResponse>;
    public abstract getConfiguration(customerId: number, locationId: number): Observable<FlexMonitorConfiguration>;
    public abstract getLocationDetails(customerId: number, locationId: number): Observable<LocationDetails[]>;
    public abstract getSensors(deviceId: string, customerId: number): Observable<SensorConfigurationCollection>;
    public abstract getLatestHydrograph(
        customerId: number,
        locationId: number,
        entityIds: number[],
    ): Observable<OptimizedViewData | null>;
    public abstract getInstallationDrawing(
        customerId: number,
        locationId: number,
    ): Observable<FlexInstallationDrawingData>;
    public abstract getDateContext(customerId: number): Observable<FlexDateContext>;
    public abstract getDiagnosticUnits(customerId: number): Observable<ApiUnitsRow[]>;
    public abstract queueDiagnostics(
        customerId: number,
        locationId: number,
    ): Observable<FlexDiagnosticCommandResponse[] | null>;
    public abstract getDiagnosticLogs(
        customerId: number,
        locationId: number,
        request: MonitorDiagnosticLogsRequest,
    ): Observable<MonitorDiagnosticLog[] | null>;
    public abstract getDiagnosticNotifications(): Observable<SignalRMessage>;
}
